import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";
import { _showToast } from "../../../../../toastHelper";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import "./themecustomization.css";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";



const TemplateCustomization = forwardRef(function TemplateCustomization(
  props,
  ref
) {
  const [expiration, setExpiration] = useState(7);
  const [eventName, setEventName] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [liveUrl, setLiveUrl] = useState("");
  const [pageUrl, setpageUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [imageKey, setImageKey] = useState("");
    const [section2ImageKey, setSection2ImageKey] = useState("");

  const [backgroundColor1, setBackgroundColor1] = useState("#000000");
  const [backgroundColor2, setBackgroundColor2] = useState("#3f3b3b");
  const [heading1, setHeading1] = useState("#e40c0c");
  const [heading2, setHeading2] = useState("#f79308");
  const [paragraph, setParagraph] = useState("#ffffff");
  const [copyrigth, setCopyright] = useState("#9e0bb1");
  const [socialmedia, setSocialmedia] = useState("#43da25");
  const [button, setButton] = useState("#8b2727");

  const thumbnailRef = useRef();
  const section2ImageRef = useRef();
  const [datapass, setDatapass] = useState();

  useEffect(() => {
    resetData();
    if (props.data) {
      setEventDate(props.data.eventDate);
      setEventName(props.data.title);
      setExpiration(props.data.expiration);
      setLiveUrl(props.data.liveUrl);
      setImageKey(props.data.imageKey);
      setSection2ImageKey(props.data.section2ImageKey)
      thumbnailRef?.current?.setThumbnail(
        props.data.image && props.data.image != "" ? props.data.image : null
      );
      thumbnailRef?.current?.setFileContent(props.data.imageFile);

      section2ImageRef?.current?.setThumbnail(props.data.section2ImageKey);
      section2ImageRef?.current?.setFileContent(props.data.imageFile);
    }
  }, [props.data]);

  const resetData = () => {
    setEventDate("");
    setEventName("");
    setExpiration(7);
    setLiveUrl("");
    thumbnailRef?.current?.setThumbnail(null);
    thumbnailRef?.current?.setFileContent(null);
  };

  const validate = () => {
    const errors = {};

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getData = () => {
    return {
      eventName: pageUrl,
      eventDate: eventDate,
      image: thumbnailRef?.current?.getThumbnail() ?? null,
      imageFile: datapass,
      expiration: expiration ?? 7,
      liveUrl: liveUrl,
      imageKey: datapass,

      backgroundColor1: backgroundColor1,
      backgroundColor2: backgroundColor2,
      heading1: heading1,
      heading2: heading2,
      paragraph: paragraph,
      copyrigth: copyrigth,
      socialmedia: socialmedia,
      button: button,
    };
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate,
  }));
  const handleCroppedImage = (file) => {
    setDatapass(file);    
   
  };
  const [imagePreview, setImagePreview] = useState(null);
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    console.log("file",file)
    setDatapass(file)
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); 
      };
      reader.readAsDataURL(file);
    }
  };
  return (
    <>
      <div
        className="content"
        style={{ display: "block", visibility: "visible" }}
      >
        <div className="content-header mb-3">
          <div className="sec-titler">
            <h2 className="text-primary">Theme Customization</h2>
            <div className="title-shape"></div>
          </div>
        </div>
        <form>
          <div className="row mt-4">
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Background Color 1
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.backgroundColor1 ? "is-invalid" : ""
                  }`}
                  value={backgroundColor1}
                  onChange={(e) => setBackgroundColor1(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: backgroundColor1,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.backgroundColor1 ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={backgroundColor1}
                  onChange={(e) => setBackgroundColor1(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.backgroundColor1 && (
                <div className="invalid-feedback">{errors.backgroundColor1}</div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Background Color 2
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.backgroundColor2 ? "is-invalid" : ""
                  }`}
                  value={backgroundColor2}
                  onChange={(e) => setBackgroundColor2(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: backgroundColor2,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.backgroundColor2 ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={backgroundColor2}
                  onChange={(e) => setBackgroundColor2(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.backgroundColor2 && (
                <div className="invalid-feedback">{errors.backgroundColor2}</div>
              )}
            </div>

            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Heading 1
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.heading1 ? "is-invalid" : ""
                  }`}
                  value={heading1}
                  onChange={(e) => setHeading1(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: heading1,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.heading1 ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={heading1}
                  onChange={(e) => setHeading1(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.heading1 && (
                <div className="invalid-feedback">{errors.heading1}</div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Heading 2
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.backgroundColor2 ? "is-invalid" : ""
                  }`}
                  value={heading2}
                  onChange={(e) => setHeading2(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: heading2,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.heading2 ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={heading2}
                  onChange={(e) => setHeading2(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.heading2 && (
                <div className="invalid-feedback">{errors.heading2}</div>
              )}
            </div>

            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
              paragraph color
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.paragraph ? "is-invalid" : ""
                  }`}
                  value={paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: paragraph,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.paragraph ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={paragraph}
                  onChange={(e) => setParagraph(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.paragraph && (
                <div className="invalid-feedback">{errors.paragraph}</div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Footer color
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.copyrigth ? "is-invalid" : ""
                  }`}
                  value={copyrigth}
                  onChange={(e) => setCopyright(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: copyrigth,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.copyrigth ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={copyrigth}
                  onChange={(e) => setCopyright(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.copyrigth && (
                <div className="invalid-feedback">{errors.copyrigth}</div>
              )}
            </div>

            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Icons color
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.socialmedia ? "is-invalid" : ""
                  }`}
                  value={socialmedia}
                  onChange={(e) => setSocialmedia(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: socialmedia,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.socialmedia ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={socialmedia}
                  onChange={(e) => setSocialmedia(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.socialmedia && (
                <div className="invalid-feedback">{errors.socialmedia}</div>
              )}
            </div>
            <div className="col-sm-6">
              <label className="form-label required" htmlFor="primaryColor">
                Button color
              </label>
              <div className="d-flex align-items-center">
                <input
                  type="color"
                  id="primaryColor"
                  name="primaryColor"
                  className={`form-control color-input ${
                    errors.button ? "is-invalid" : ""
                  }`}
                  value={button}
                  onChange={(e) => setButton(e.target.value)}
                  style={{
                    width: "50px",
                    height: "50px",
                    padding: 0,
                    borderRadius: "50%",
                    border: "2px solid #000",
                    backgroundColor: button,
                  }}
                />
                <input
                  type="text"
                  id="primaryColorHex"
                  name="primaryColorHex"
                  className={`form-control ml-2 ${
                    errors.copyrigth ? "is-invalid" : ""
                  }`}
                  placeholder="#000000"
                  value={button}
                  onChange={(e) => setButton(e.target.value)}
                  style={{ marginLeft: "10px" }}
                />
              </div>
              {errors.button && (
                <div className="invalid-feedback">{errors.button}</div>
              )}
            </div>
           
           

            <div className="col-sm-6 mt-3">
              <label className="form-label required" htmlFor="pageTitle">
                Page Html Title
              </label>
              <input
                  type="text"
                id="pageTitle"
                name="pageTitle"
                className={`form-control ${
                  errors.eventDate ? "is-invalid" : ""
                }`}
                placeholder="Please enter Page Title here"
                value={eventDate}
                onChange={(e) => setEventDate(e.target.value)}
              />
            </div>
            <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="pageurl">
               Page Url Formation
              </label>
              <input
                  type="text"
                id="pageurl"
                name="pageurl"
                className={`form-control ${errors.pageUrl ? "is-invalid" : ""}`}
                placeholder="Please Enter Page Url Formation"
                value={pageUrl}
                onChange={(e) => setpageUrl(e.target.value)}
              />
              {errors.pageUrl && (
                <div className="invalid-feedback">{errors.pageUrl}</div>
              )}
            </div>


            {/* <div className="col-sm-6 mt-3">
              <label className="form-label" htmlFor="section1Image">
                Logo Image{" "}
                <small className="text-gray">
                  (Max Allowable File Size: 1MB,Dimensions: 750px x 750px)
                </small>
              </label>
              <ImageBrowse
                elementId="section2Image"
                ref={section2ImageRef}
                imageType="profile"
                imageKey={section2ImageKey}
                setImageKey={setSection2ImageKey}
                imageDelete={props.imageDelete}
                onImageCropped={handleCroppedImage}

              />
            </div> */}
            <div className="col-sm-6 mt-3">
      <label className="form-label" htmlFor="section1Image">
        Logo Image{" "}
        <small className="text-gray">
          (Max Allowable File Size: 1MB, Dimensions: 750px x 750px)
        </small>
      </label>
      <input
        type="file"
        id="section1Image"
        accept="image/*"
        className="form-control"
        onChange={handleImageChange} // Handle file selection
      />

      {/* Show the preview below */}
      {imagePreview && (
        <div className="mt-3">
          <img
            src={imagePreview}
            alt="Selected Preview"
            className="img-thumbnail"
            style={{ maxWidth: "200px", height: "auto" }}
          />
        </div>
      )}
    </div>

          
          </div>

          <StepperNavigationButtons
            index={props.index}
            steps={props.steps}
            navigate={props.navigate}
            save={props.save}
          />
        </form>
      </div>
    </>
  );
});

export default TemplateCustomization;
